import gql from 'graphql-tag';

import type { UtilityContext } from '@change/core/react/utilityContext';

import type {
	GammaPetitionPageUserInfoQuery,
	GammaPetitionPageUserInfoQueryVariables,
} from './userPetitionInfo.graphql';

type PartialPetition = NonNullable<GammaPetitionPageUserInfoQuery['petition']>;

export async function getUserPetitionInfo(
	slugOrId: string,
	{ gql: { fetch } }: UtilityContext,
): Promise<PartialPetition> {
	const { data } = await fetch<GammaPetitionPageUserInfoQuery, GammaPetitionPageUserInfoQueryVariables>({
		query: gql`
			query GammaPetitionPageUserInfo($slugOrId: String!) {
				petition: petitionBySlugOrId(slugOrId: $slugOrId) {
					id
					viewerCanEdit
					user {
						id
					}
				}
			}
		`,
		variables: { slugOrId },
	});
	if (!data?.petition) {
		throw new Error('failed to retrieve petition info');
	}
	return data?.petition;
}
